import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { SINGLE_FIELD_SEARCH_QUERY } from '../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../Spinner/Spinner.js'
import { getData, getInputParams, sortColumnClicked } from './CustomUtils'
import './Custom.css'
import ColumnHeadings from './ColumnHeadings.js'
import ReportGrid from './ReportGrid.js'
import ReportHeading from './ReportHeading.js'

const SINGLE_FIELD_SEARCH = gql(SINGLE_FIELD_SEARCH_QUERY)

export default function SingleFieldSearch({ location }) {
  console.log('SingleFieldSearch rendered:', location)

  const navigate = useNavigate()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, SINGLE_FIELD_SEARCH, 'singleFieldSearch', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    const inputs = getInputParams(location)
    let viewButtonIndex = 1
    if (results.reportData.length > 0) {
      viewButtonIndex = results.reportData[0].length - 1
    }
    return (
      <div className="custom-scroll">
        <Table bordered style={{ padding: '.25rem', width: 'auto', margin: 'auto' }}>
          <ReportHeading title='Index Item Search' width={['0%', '50%', '50%']} />
          <tbody>
            <ColumnHeadings results={results} inputs={inputs} sortColumnClicked={sortColumnClicked} location={location} navigate={navigate} setResults={setResults} />
            <ReportGrid results={results} viewButtonDataIndex={viewButtonIndex} location={location} ignoreRowIndex={viewButtonIndex} />
          </tbody>
        </Table>
      </div>
    )
  }
}
